@if (userGuide | async ; as item) {
  <div class="account-section-content createprofile_cdccontent col-xs-12 col-md-12 margin-T10"
    >
    <div class="col-xs-12 col-md-12 createprofile_helptext">
      @if (!userLoggedIn && item.uid=='SeqirusCreateProfileUserGuidePDFComponent') {
        <div id="breadcrumb" class="col-xs-12 col-md-6">
          <ol class="breadcrumb">
            <li><a href="/">{{"statictext.home" | cxTranslate}}</a></li>
            &nbsp; &gt; &nbsp;
            <li class="bc_bold">{{"statictext.createAccount" | cxTranslate}}</li>
          </ol>
          <!-- <a [routerLink]="['/profileverification']">verify profile</a> -->
        </div>
      }
      @if (!userLoggedIn && item.uid=='SeqirusEmailVerificationNeedHelpComponent') {
        <div id="breadcrumb-emailverification" class="col-xs-12">
          <ol class="breadcrumb">
            <li><a href="/">{{"statictext.home" | cxTranslate}}</a></li>
            &nbsp; &gt; &nbsp;
            <li class="bc_bold">{{"statictext.createAccount" | cxTranslate}}</li>
          </ol>
        </div>
      }
      @if (!userLoggedIn) {
        <div>
          <div class="global_breadcrumbs_helpnfaq col-md-6 col-lg-6 col-xs-12 d-none"><span
            class="global_breadcrumblink">
            <a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a></span>&gt;<span class="global_breadcrumbactive">{{"statictext.helpnfaq" | cxTranslate}}</span>
          </div>
        </div>
      }
      <!-- For tools and resources Mobile view breadcrumbs-->
      @if (!userLoggedIn) {
        <div class="breadcrumbs--page-nav tools_Resource_Breadcrumbs_Mobile col-md-12 d-none">
          <div class="container">
            <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><strong> {{"statictext.toolsnresources" | cxTranslate}}</strong></p></div>
          </div>
        }
        <div class="userguideparent">
          <span class="userguidegrey">{{item.headline}} </span>
          <a class="userguideanchor" [href]="getImage(item.media)" target="_blank"><span
          class="userguideblack anchorunderline">{{item.h2content}}</span>
          <div class="global_blackarrow black_arrow_class"></div>
        </a>
      </div>
      @if (!userLoggedIn) {
        <div>
          <div class="global_breadcrumbs_helpnfaq_mobile col-md-12 col-lg-12 col-xs-12 d-none"><span
            class="global_breadcrumblink">
            <a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a></span>&gt;<span class="global_breadcrumbactive">{{"statictext.helpnfaq" | cxTranslate}}</span>
          </div>
        </div>
      }
    </div>
  </div>
}